/**
 * @generated SignedSource<<b422de9371924548496d39eb302c5247>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductizedServicePriceType = "CONTACT_FOR_PRICING" | "FIXED_PRICE" | "RATE" | "%future added value";
export type ProductizedServiceType = "BUY_NOW_INSTANT_PURCHASE" | "BUY_NOW_OTHER" | "BUY_NOW_REQUEST" | "NOT_PURCHASABLE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ServiceInquiryButton_productizedService$data = {
  readonly analyticsId: number;
  readonly id: string;
  readonly price: {
    readonly type: ProductizedServicePriceType;
  };
  readonly productizedServiceType: ProductizedServiceType | null;
  readonly userProfile: {
    readonly analyticsId: number;
    readonly displayUsername: string;
    readonly generalInquiryCtaIsVisible: boolean;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"DiscoverUnauthenticatedInquiryModal_profile">;
  };
  readonly " $fragmentType": "ServiceInquiryButton_productizedService";
};
export type ServiceInquiryButton_productizedService$key = {
  readonly " $data"?: ServiceInquiryButton_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceInquiryButton_productizedService">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "analyticsId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceInquiryButton_productizedService",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServicePrice",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productizedServiceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "generalInquiryCtaIsVisible",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUsername",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DiscoverUnauthenticatedInquiryModal_profile"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};
})();

(node as any).hash = "d0a19837ea3720c8faee71a5d0a3f871";

export default node;
